// SF 監査ラン履歴 API クライアント。GET /sf/audit/runs(一覧) / /sf/audit/runs/{id}(詳細)。
// ApiClient に認証・エラー正規化を委譲。backend RunSummary/RunRecord に対応する DTO。
import type { ApiClient } from "../api/client";
import type { RunAuditFinding } from "./audit-api";

export interface HistoryApiDeps {
  readonly apiClient: ApiClient;
}

export interface RunCountsDto {
  readonly critical: number;
  readonly high: number;
  readonly medium: number;
  readonly low: number;
}

export interface RunSummaryDto {
  readonly runId: string;
  readonly runAt: string;
  readonly healthCheckScore: number;
  readonly counts: RunCountsDto;
  readonly orgId: string;
  readonly trigger: "manual" | "scheduled";
  readonly actorSub: string;
}

export interface RunDetailDto extends RunSummaryDto {
  readonly findings: RunAuditFinding[];
  readonly coverage: { readonly evaluated: string[]; readonly notEvaluated: string[] };
}

// GET /sf/audit/runs → RunSummaryDto[]（新しい順は backend が保証）
export async function listRuns(deps: HistoryApiDeps): Promise<RunSummaryDto[]> {
  return deps.apiClient.get<RunSummaryDto[]>("/sf/audit/runs");
}

// GET /sf/audit/runs/{runId} → RunDetailDto（findings 込み）
export async function getRun(deps: HistoryApiDeps, runId: string): Promise<RunDetailDto> {
  return deps.apiClient.get<RunDetailDto>(`/sf/audit/runs/${encodeURIComponent(runId)}`);
}
